'use client';

import { lookupIcon } from 'heroicons-lookup';

export default function HomeFeature({ index, icon, iconTitle, title,  text }) {
    const Icon = lookupIcon(icon, "outline");
    const titleId = `feature-icon-title-${index}`;
    return(
        <div className="flex flex-col items-stretch gap-4">
            <div className="flex items-center gap-3">
                <Icon className="text-purple01 h-6" role="img" aria-hidden="false" aria-labelledby={titleId}/>
                <span id={titleId} className="sr-only">{iconTitle}</span>
                <h3 className="font-vg-medium text-black text-2xl">{title}</h3>
            </div>
            <p className="font-vg-book text-black text-base">{text}</p>
        </div>
    );
}